import { render, staticRenderFns } from "./init_menu.vue?vue&type=template&id=09bc9b02&scoped=true&"
import script from "./init_menu.vue?vue&type=script&lang=js&"
export * from "./init_menu.vue?vue&type=script&lang=js&"
import style0 from "./init_menu.vue?vue&type=style&index=0&id=09bc9b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bc9b02",
  null
  
)

export default component.exports